// Phase 9.6.2 — Merchandise tab. Uses the shared
// `LocationSegmentedListing` so the layout stays 1:1 with Bar Stock.

import LocationSegmentedListing from "./LocationSegmentedListing";

export default function FnbPoMerchandise() {
  return (
    <div className="max-w-7xl mx-auto py-6 px-4">
      <LocationSegmentedListing
        title="Merchandise"
        itemScope="merchandise"
        helperText="Retail-side inventory: apparel, accessories, and any SKU classified by category, sub-category, MC_ prefix, or Sheet-2 origin as merchandise. Excluded from Daily Stock reorder math."
        emptyText="No merchandise items configured. Upload a stock workbook with a merchandise sheet to seed this scope."
      />
    </div>
  );
}
